import React, { useState, useEffect, useRef } from "react";
import FontPicker from "font-picker-react";
import TabbedPanel from "../../../../components/TabbedPanel/TabbedPanel";
import FormDropDown from "../../../../components/forms/DropDownList/FormDropDown";
import { applyFontPreview, FontPreviewBlock, getCustomFontUrl } from "../../../../helpers/CustomFonts";
import { slideOutPanelControl } from "../SlideoutPanel";
import LottieIcon from "../../../../components/common/LottieIcon";
import { getIconCategoryClass } from "../../../../components/common/iconCategory";
import './DisruptorSelectorContent.scss';

const DisruptorSelectorContent = (props) => {
    console.log("Rendering DisruptorSelectorContent with props:", props);
    // const disruptorCustomisationSchema = get

    const restrictItemsToVarKey = props.customisationSchema.subType;
    const availableLibraryItems = [];
    for (let i = 0; i < props.libraryItems?.Campaign?.length; i++) {
        const item = props.libraryItems.Campaign[i];
        if (item.id !== props.selectedFeatureNode.id && (item.varKey === restrictItemsToVarKey || restrictItemsToVarKey === undefined || restrictItemsToVarKey === null || restrictItemsToVarKey === '')) {
            availableLibraryItems.push(item);
        }
    }

    const handleSelectDisruptor = (disruptorId) => {
        console.log('Selected disruptor ID:', disruptorId);
        if (props.onDisruptorSelected) {
            props.onDisruptorSelected(disruptorId);
        }
    }

    return (
        <div className="library-tab-content" onWheel={(e) => e.stopPropagation()}>
            <div className="v2-select-disruptor-grid">
                {availableLibraryItems.length === 0 && (
                    <div>
                        No disruptors available to add. You may need to add some disruptor features to your campaign first.
                    </div>
                )}
                {availableLibraryItems.length > 0 && availableLibraryItems.map((item) => (
                    <div
                        key={`${item.id}-${item.label}`}
                        className={`library-item-card${props.currentDisruptor === item.id ? ' active' : ''}`}
                        // draggable
                        // onDragStart={(event) => onDragStart && onDragStart(item, event)}
                        // onDragEnd={(event) => onDragEnd && onDragEnd(event)}
                        onClick={() => handleSelectDisruptor(item.id)}
                    >
                        <div className={`item-image-placeholder category-icon-bg--${getIconCategoryClass((Array.isArray(item.itemCategory) ? item.itemCategory[0] : item.itemCategory) || item.category)}`}>
                        <LottieIcon icon={item.icon} varKey={item.varKey} size={40} />
                        </div>
                        <div className="item-name">{item.label}</div>
                    </div>
                ))}
            </div>
            <div className="selected-disruptor-info">
                <div className="remove-button-row">
                    <div 
                        className="clear-disruptor-link"
                        onClick={() => handleSelectDisruptor('')}
                    >
                        Clear Selection
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DisruptorSelectorContent;
